import { APIURL } from "../../../../configApi/apiConfig";

export const DOCS_DIGITALES_BS = [
  "Contrato de Compra",
  "Declaracion",
  "Pagare a la Orden",
  "Tabla de amortizacion",
  "Gastos de cobranza",
  "Compromiso Lugar de pago",
  "Consentimiento",
  "Autorización",
];

// De los documentos digitales de esta pantalla, estos 3 necesitan que la solicitud ya tenga
// una compra (prefactura) registrada en Banco Solidario (Compra por
// idCre_SolicitudWeb + idTipoFactura=43) para poder generarse con datos
// reales (monto, tasas, tabla de amortización). Sin eso, no se generan: se
// muestra un mensaje de "falta la prefactura" en su lugar.
export const DOCS_QUE_REQUIEREN_COMPRA_BS = [
  "Contrato de Compra",
  "Pagare a la Orden",
  "Tabla de amortizacion",
];

export const ENDPOINTS_DIGITALES_BS = {
  "Contrato de Compra":       APIURL.getContratoCompraVenta,
  "Declaracion":              APIURL.getDeclaracion,
  "Pagare a la Orden":        APIURL.getPagareOrden,
  "Tabla de amortizacion":    APIURL.getTablaAmortizacion,
  "Gastos de cobranza":       APIURL.getGastosCobranza,
  "Compromiso Lugar de pago": APIURL.getCompromisoLugarPago,
  "Consentimiento":           APIURL.getConsentimiento,
  "Autorización":             APIURL.getAutorizacionDatos,
};

// Papeleta de votación: obligatoria solo en solicitudes de MOTOS (Cre_SolicitudWeb.idProductos = 10).
export const DOC_PAPELETA_MOTOS_BS = "PAPELETA DE VOTACIÓN - MOTOS";
export const ID_PRODUCTO_MOTOS = 10;

export const MENU_ITEMS_BS = [
  "Contrato de Compra",
  "Declaracion",
  "Pagare a la Orden",
  "Tabla de amortizacion",
  "Gastos de cobranza",
  "Compromiso Lugar de pago",
  "Consentimiento",
  "Autorización",
  "Copia De Cedula",
  "Foto del Cliente",
  "Foto Casa",
  "Servicio Basico",
  "Foto Trabajo",
  "Foto del Cliente Firmando",
  "Respaldo 1",
  "Respaldo 2",
  "Respaldo 3",
  "Respaldo 4",
  "Respaldo 5",
  "Respaldo 6",
  "Respaldo 7",
  "Respaldo 8",
  "Respaldo 9",
  "Respaldo 10",
];

export const DOCUMENTO_IDS_BS = {
  "Copia De Cedula": 2,
  "Contrato de Compra": 3,
  "Declaracion": 4,
  "Pagare a la Orden": 5,
  "Tabla de amortizacion": 6,
  "Gastos de cobranza": 7,
  "Compromiso Lugar de pago": 8,
  "Consentimiento": 10,
  "Autorización": 11,
  "Foto del Cliente": 12,
  "Foto Casa": 13,
  "Servicio Basico": 14,
  "Foto del Cliente Firmando": 15,
  "Respaldo 1": 16,
  "Respaldo 2": 17,
  "Respaldo 3": 18,
  "Respaldo 4": 19,
  "Respaldo 5": 20,
  "Respaldo 6": 21,
  "Respaldo 7": 22,
  "Respaldo 8": 23,
  "Respaldo 9": 24,
  "Respaldo 10": 25,
  "Foto Trabajo": 26,
  [DOC_PAPELETA_MOTOS_BS]: 27,
};

// Crédito Directo no se solicita en Documental: Crédito Back lo genera
// directamente al crear la tarea de firma en DataAgree.
export const TOTAL_REQUIRED_BS = 14;

export const getNumeroDocumento = (nombre) => DOCUMENTO_IDS_BS[nombre] ?? null;
export const isDocumentoDigital = (nombre) => DOCS_DIGITALES_BS.includes(nombre);
export const isRespaldo = (nombre) => nombre.startsWith("Respaldo ");

// Los documentos digitales siempre se muestran en el menú (los que
// requieren compra y aún no la tienen se ven con un mensaje de "falta
// prefactura" en vez de generarse, ver DOCS_QUE_REQUIEREN_COMPRA_BS).
// En MOTOS se agrega la Papeleta de votación (obligatoria) antes de los Respaldos.
export const getMenuItemsBs = (esSolicitudMotos = false) => {
  if (!esSolicitudMotos) return MENU_ITEMS_BS;
  const idxRespaldos = MENU_ITEMS_BS.indexOf("Respaldo 1");
  return [
    ...MENU_ITEMS_BS.slice(0, idxRespaldos),
    DOC_PAPELETA_MOTOS_BS,
    ...MENU_ITEMS_BS.slice(idxRespaldos),
  ];
};

// Los 4 documentos que dependen de compra siempre cuentan para el total
// requerido, tenga o no la solicitud una compra registrada todavía: mientras
// no existan, el progreso no llega a 100% y el botón "Enviar verificación"
// (que solo se muestra en 100%) queda bloqueado hasta que se generen.
// En MOTOS se suma la Papeleta de votación (14 + 1).
export const getTotalRequiredBs = (esSolicitudMotos = false) => TOTAL_REQUIRED_BS + (esSolicitudMotos ? 1 : 0);

export const FIRMA_ESTADOS_BS = {
  1: { label: "Pendiente",               badge: "bg-slate-100 text-slate-600" },
  2: { label: "Link Enviado",            badge: "bg-amber-100 text-amber-700" },
  3: { label: "Aceptado",               badge: "bg-emerald-100 text-emerald-700" },
  4: { label: "Prueba Vida Procesando", badge: "bg-violet-100 text-violet-700" },
  5: { label: "Prueba de Vida",         badge: "bg-blue-100 text-blue-700" },
  6: { label: "Firmado",                badge: "bg-teal-100 text-teal-700" },
  7: { label: "Rechazado",              badge: "bg-rose-100 text-rose-700" },
};
